import { render, staticRenderFns } from "./TeacherSchools.vue?vue&type=template&id=33695aa5&"
import script from "./TeacherSchools.vue?vue&type=script&lang=js&"
export * from "./TeacherSchools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports